var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limiter"},[_c('div',{staticClass:"container-login100"},[_c('div',{staticClass:"scan"},[_c('h1',[_vm._v("QR Code Scanner")]),_c('qriously',{attrs:{"value":_vm.qrCodeData,"size":"200","level":"H"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }